import styled from '@emotion/styled';
import { Modal } from '@ui-components/neo.tax';

export const ModalStyled = styled(Modal)({
  width: 540,
  maxWidth: 540,
});
